import { SideBarContext, SideBarContextType } from "@cdv/jazz-ui";
import { Box, CssBaseline } from "@mui/material";
import { ReactElement, useContext } from "react";
import { Outlet } from "react-router";

export default function Layout(): ReactElement {
  const { isTemporary, isNarrow } = useContext<SideBarContextType>(SideBarContext);

  return (
    <Box sx={{ display: "flex", background: "#EEF6F8", minHeight: "100vh" }}>
      <CssBaseline />
      <Outlet />
    </Box>
  );
}
